import type { Calendar } from 'owa-calendar-cache';
import { getStore } from '../store/store';

export function isLocalLieCalendar(calendar: Calendar): boolean {
    return getStore().localLieCalendarIds.has(calendar.id.id);
}
